<template>
  <div>
    <transition name="pagina">
        <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  export default {}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue